import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent, ContextMenuItem, FaIconComponent } from '@akostm/orbit-ui';
import { faUser, faEnvelope, faCaretUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'shared-profile-menu',
  imports: [CommonModule, FaIconComponent, ButtonComponent],
  templateUrl: './profile-menu.component.html',
  styleUrl: './profile-menu.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileMenuComponent {
  readonly faUser = faUser;
  readonly faEnvelope = faEnvelope;
  readonly bubbleArrow = faCaretUp;

  readonly name = input.required<string>();
  readonly email = input.required<string>();
  readonly resetPasswordButtonLabel = input<string>('Reset Password');
  readonly logoutButtonLabel = input<string>('Logout');

  readonly closeOverlay = output();
  readonly logout = output();
  readonly resetPassword = output();

  logoutClicked() {
    this.logout.emit();
  }

  resetPasswordClicked() {
    this.resetPassword.emit();
  }
}
